(function (appComponents) {

	appComponents.services.checkoutProfileBase = function (Components) {

		var checkoutProfileBase = {};

		checkoutProfileBase.name = "checkoutProfileBase";

		Components.getComponentPrototype().extend(checkoutProfileBase);

		checkoutProfileBase.elements = {
			// get cartSizeWidget() {
			// 	return $('[pc-container="cart--size-widget"]');
			// }
		};

		checkoutProfileBase.bindings = function () {
			// $(document).on("click", '[pc-container="cart--add-item"]', function () {
			// 	var productCode = $(this).parents('[pc-container="product-item"]').attr("pc-value");
			// 	checkoutProfileBase.handlers.onAddItem(productCode);
			// });
		};

		checkoutProfileBase.getProfiles = function () {
			return checkoutProfileBase._api.checkoutProfile.getProfiles().then(function (res) {
				if (res && res.status == 200) {
					return res.body;
				} else {
					return false;
				}
			});
		};

		checkoutProfileBase.applyProfile = function (code) {
			return checkoutProfileBase._api.checkoutProfile.applyProfile(code).then(function (res) {
				if (res && res.status == 200) {
					return true;
				} else {
					return false;
				}
			});
		};

		checkoutProfileBase.handlers = {

		};

		checkoutProfileBase.init = function () {

			checkoutProfileBase._bindings();

		};

		return checkoutProfileBase;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});